<p-dialog
  header="Create New Session"
  [(visible)]="visible"
  (onHide)="onCancel()"
  [modal]="true"
  [style]="{width: '500px', minWidth: '400px'}"
  [closable]="!loading">

  <div class="mb-4">
    <p class="text-600 mb-3">Create a new GoVideo session. The session ID can be customized or you can use the auto-generated one.</p>
  </div>

  <form [formGroup]="sessionForm" (ngSubmit)="onSave()">
    <div class="mb-4">
      <label for="sessionId" class="block font-medium mb-2">
        Session ID <span class="text-red-500">*</span>
      </label>
      <div class="p-inputgroup">
        <input
          id="sessionId"
          type="text"
          pInputText
          formControlName="sessionId"
          placeholder="Enter session ID"
          class="flex-1"
          [class.ng-invalid]="isFieldInvalid('sessionId')"
          [disabled]="loading"
          (input)="onSessionIdInput($event)">
        <button 
          type="button"
          class="p-inputgroup-addon p-button p-button-outlined"
          (click)="generateNewSessionId()"
          [disabled]="loading"
          title="Generate new session ID">
          <i class="pi pi-refresh"></i>
        </button>
      </div>
      @if (isFieldInvalid('sessionId')) {
        <small class="p-error block mt-1">
          {{ getFieldError('sessionId') }}
        </small>
      }
      <small class="text-500 block mt-1">
        Use a unique 4+ character code. Only letters, numbers, hyphens (-), and underscores (_) allowed. Spaces will be converted to hyphens.
      </small>
    </div>
  </form>

  <ng-template pTemplate="footer">
    <div class="flex justify-content-end gap-2">
      <p-button
        label="Cancel"
        icon="pi pi-times"
        styleClass="p-button-outlined"
        (onClick)="onCancel()"
        [disabled]="loading">
      </p-button>
      <p-button
        label="Create Session"
        icon="pi pi-plus"
        (onClick)="onSave()"
        [loading]="loading"
        [disabled]="sessionForm.invalid">
      </p-button>
    </div>
  </ng-template>
</p-dialog>
